<template>
<!--   TABLA POR OD-->
      <div>
        <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <b-row class="text-center pl-3 pr-4">
          <b-col class=" text-left" :class="existeCardActiva ? 'textoActivo' : 'thtable'" style="padding-left: 22px;">Órgano dental</b-col>
          <b-col class="thtable" :class="existeCardActiva ? 'textoActivo' : 'thtable'">No. tratamientos</b-col>
          <b-col class="thtable" :class="existeCardActiva ? 'textoActivo' : 'thtable'" v-if="existePlan || aplicaPromocionesTx">Precio Subtotal</b-col>
          <b-col class="thtable" :class="existeCardActiva ? 'textoActivo' : 'thtable'" v-if="existePlan">Descuento plan</b-col>
          <b-col class="thtable" :class="existeCardActiva ? 'textoActivo' : 'thtable'" v-if="aplicaPromocionesTx"> Descuento promo </b-col>
          <b-col class="thtable" :class="existeCardActiva ? 'textoActivo' : 'thtable'">Inversión total</b-col>
          <b-col cols="1" class="thtable"></b-col>
        </b-row>
        <hr style="margin-top: 3px; border: 0; height: .1vh; background: #D6E7F3;">

        <div class="scrollable-container no-horizontal-scroll" v-if="tratamientosPrioridadPorOD.length > 0">
          <div v-for="(me, index) in tratamientosPrioridadPorOD.filter(tp => tp.clasificacion === 1)" :key="index">
            <b-card :class="cardSeleccionado === index ? 'cardSe seleccionado' : 'cardCerrada'" class="mt-2 mb-1" v-if="me.tratamientos.length > 0">
              <b-row class="text-center">
                <b-col :class="cardSeleccionado === index ? 'cardSeTitle seleccionado' : 'cardSeTitle'"
                     style="font-size: 9px;"
                     class="text-left pr-0">
               <div class="d-flex">
                <em class="dienteCepillo" style="margin-top: -20%;"></em>
                <p>{{ me.diente }}</p>
                <em v-if="me.tieneArgumentario" v-b-tooltip.hover.topleft.v-light
                    title="Ver argumentario"
                    class="info_padecimiento"
                    style="position: relative !important; margin-bottom: -3px; cursor: pointer; width: 12px;
  "
                    @click="verArgumentario(me.nombreKit == null ? me.idTratamiento : null, me.nombreKit == null ? me.tratamiento : me.nombreKit, me.nombreKit == null ? [] : me.tratamientos)"></em>
               </div>
              </b-col>
                <b-col class="leterSize ml-2">
                  <p>{{ me.tratamientos.filter(tp => tp.clasificacion === 1).length }}</p>
                </b-col>
                <b-col v-if="existePlan || aplicaPromocionesTx" class="leterSize" >
                  {{ me.subtotal | monedaEntero }}
                </b-col>
                <b-col v-if="existePlan" class="leterSize">
                  {{ me.descuentoPlan | monedaEntero }}
                </b-col>
                <b-col v-if="aplicaPromocionesTx" class="leterSize">
                  {{ me.descuentoPromo | monedaEntero }}
                </b-col>
                <b-col class="leterSize">
                  {{ me.inversionTotal | monedaEntero }}
                </b-col>
                <b-col  cols="1">
                  <div>
                  <b-button v-if="cardSeleccionado === index" pill size="sm" variant="outline-ligth"
                            @click="deseleccionarCard()"
                            :id="'chevron-'+index" :key="'chevron-'+index" v-b-toggle="'collapseDetailOD-'+index"
                            style="margin-top: -12px;"
                  >
                    <b-icon
                        style="color: #4FB0B7;  font-size: 10px; height: 14px"
                        icon="chevron-up"
                    ></b-icon>
                  </b-button>
                  <b-button v-else pill size="sm" variant="outline-ligth" @click="seleccionarCard(me.tratamientos, index)"
                            :id="'chevron-'+index" :key="'chevron-'+index" v-b-toggle="'collapseDetailOD-'+index"
                            style="margin-top: -12px;"
                  >
                    <b-icon
                        style="color: #4FB0B7;  font-size: 10px; height: 14px"
                        icon="chevron-down"
                    ></b-icon>
                  </b-button>
                </div>
                </b-col>
              </b-row>

              <b-collapse :id="'collapseDetailOD-'+index"  accordion="my-accordion-detalle" role="tabpanel">
              <div class="p-3" style="border: 1px solid #F3F3F3; border-radius: 20px;">
                <div class="row text-center" style="max-height: 30px">
                  <div class="col-3 d-flex justify-content-center align-items-center" style="border-right: 1px solid #DBDBDB; max-height: 30px">
                    <p class="mt-3 headerTxt">Tratamientos y combos</p>
                  </div>
                  <div class="col ml-3 d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                      <p class="mt-3 headerTxt">Cantidad</p>
                  </div>
                  <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                      <p class="headerTxt">Precio unitario</p>
                  </div>
                  <div v-if="existePlan || aplicaPromocionesTx" class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                      <p class="mt-3 headerTxt">Subtotal</p>
                  </div>
                  <div v-if="existePlan" class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                      <p class="headerTxt">Descuento plan</p>
                  </div>
                  <div v-if="aplicaPromocionesTx" class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                      <p class="headerTxt">Descuento promo</p>
                  </div>
                  <div class="col d-flex justify-content-center align-items-center mr-2" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                    <p class="mt-3 headerTxt">Total</p>
                  </div>
                </div>

                <div class="" v-for="(lista, index1) in me.tratamientos.filter(t => t.clasificacion === 1)" :key="index1">
                  <b-row class="text-center">
                    <b-col cols="3" class="pt-2 d-flex justify-content-center" style="border-right: 1px solid #DBDBDB;">
                      <em v-if="!lista.agregadoACarrito"
                            class="carritoAzul" style="width: 18px; margin-right: 4px;"
                            v-b-tooltip.hover.top.v-light
                            title="Agregar al carrito"
                            @click="agregarACarrito(lista)"
                        ></em>  <!-- Por diente, individual -->
                        <em v-if="lista.banderaMovimientosHallPrio > 0"
                            class="startCircle" style="width: 18px; margin-right: 8px; cursor: pointer"
                            v-b-tooltip.hover.top.v-light
                            title="Enviar a hallazgos adicionales"
                            @click="enviarIndividualAHallazgo(lista)"
                        ></em>
                      <em v-if="lista.idKitTratamiento !== null " class="kit_svg" style="position: absolute; margin: -8px;"></em>
                      <div class="d-flex justify-content-center align-items-center p-2" :class="{'txSinAcciones' : lista.agregadoACarrito && lista.banderaMovimientosHallPrio == 0, 'txConAcciones': !lista.agregadoACarrito || lista.banderaMovimientosHallPrio > 0}" style="border: 1px solid #B9D7EC; border-radius: 20px; min-height: 35px; ">
                          <p class="m-0 bodyTxt" style="font-weight: 600;" v-if="lista.idKitTratamiento !== null">{{ lista.nombreKit }}</p>
                          <p class="m-0 bodyTxt" style="font-weight: 600;" v-else>{{ lista.tratamiento }}</p>
                      </div>
                      <em v-if="lista.tieneArgumentario" v-b-tooltip.hover.topleft.v-light
                            title="Ver argumentario"
                            class="info_padecimiento"
                            style="position: relative !important; cursor: pointer; width: .9em;"
                            @click="verArgumentario(me.nombreKit == null ? me.idTratamiento : null, me.nombreKit == null ? me.tratamiento : me.nombreKit, me.nombreKit == null ? [] : me.tratamientos)"></em>
                    </b-col>
                    <b-col class="d-flex justify-content-center align-items-center ml-3 mt-2">
                      <p class="m-0 bodyTxt"  v-if="lista.idKitTratamiento !== null">1</p>
                      <p class="m-0 bodyTxt" v-else>{{ lista.cantidadMaxima }}</p>
                    </b-col>
                    <b-col class="d-flex justify-content-center align-items-center mt-2">
                      <p class="m-0 bodyTxt" v-if="lista.idKitTratamiento !== null">{{ lista.inversionTotal | moneda}}</p>
                      <p class="m-0 bodyTxt" v-else>{{ lista.precioUnitario | moneda}}</p>
                    </b-col>
                    <b-col v-if="existePlan || aplicaPromocionesTx" class="d-flex justify-content-center align-items-center mt-2 mr-2">
                      <p class="m-0 bodyTxt">{{ lista.subtotal | moneda }}</p>
                    </b-col>
                    <b-col v-if="existePlan" class="d-flex justify-content-center align-items-center mt-2 mr-2">
                      <p class="m-0 bodyTxt">{{ lista.descuentoPlan | moneda }}</p>
                    </b-col>
                    <b-col v-if="aplicaPromocionesTx" class="d-flex justify-content-center align-items-center mt-2 mr-2">
                      <div>
                          <TagPromocionV5 v-if="lista.promocion == null && lista.idKitTratamiento === null"
                                          :promociones.sync="promociones"
                                          :tratamiento.sync="lista"
                                          :totalPrioridadClinica.sync="cantidadtotalPrioridad"
                                          @restarPromocionAplicada="restarPromocionAplicada"
                                          :agrupadoPorOd="true"
                          ></TagPromocionV5>
                          <span v-if="lista.promocion != null && lista.idKitTratamiento === null">
                              <p class="m-0 bodyTxt"> <span v-b-tooltip.hover.lefttop.v-light
                                        :title="lista.promocion.promocion"
                                        style="cursor: pointer"
                              >{{ lista.descuentoPromo | monedaEntero }} </span>
                                <em v-if=" lista.promocion.promocionForzosa === false "
                                    style="cursor: pointer"
                                    v-b-tooltip.hover.lefttop.v-light
                                    title="Quitar promoción"
                                    class="quitarPromo"
                                    @click="quitarPromoByOD(lista)"
                                ></em>
                              </p>
                          </span>
                          <span v-if="lista.idKitTratamiento !== null">
                           <p class="m-0 bodyTxt"> {{ lista.descuentoPromo |monedaEntero }}  </p>
                          </span>
                        </div>
                    </b-col>
                    <b-col class="mr-2 mt-3">
                      <span class="m-0 bodyTxt">{{ (lista.total !== null ? lista.total : 0) | moneda }} </span>
                      <b-icon v-if="lista.idKitTratamiento !== null"
                          style="color: #4FB0B7;  font-size: 10px; height: 14px; cursor: pointer;border-radius: 20px; border: solid 1px;"
                          icon="chevron-down"
                              v-b-toggle="'collapK-'+ lista.idKitTratamiento"
                      ></b-icon>
                    </b-col>
                  </b-row>

  <!--                COLLAPSE DE TRATAMIENTOS INTERNOS DE KITS   -->
                  <b-collapse :id="'collapK-'+ lista.idKitTratamiento"  :accordion="'my-accordionInternoKits' + index1" role="tabpanel">
                    <div class=" p-4" style="border: 1px solid #F3F3F3; border-radius: 20px; background-color: #FAFAFA; width: 96%; margin-left: 3%;margin-top: 4px " >
                      <div class="row text-center" style="max-height: 30px">
                        <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                          <p class="mt-3 headerTxt">Tratamiento</p>
                        </div>
                        <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                          <p class="mt-3 headerTxt">Cantidad</p>
                        </div>
                        <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                          <p class="headerTxt">Precio unitario</p>
                        </div>
                        <div v-if="existePlan || aplicaPromocionesTx" class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                          <p class="mt-3 headerTxt">Subtotal</p>
                        </div>
                        <div v-if="existePlan" class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                          <p class="headerTxt">Descuento plan</p>
                        </div>
                        <div v-if="aplicaPromocionesTx" class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                          <p class="headerTxt">Descuento promo</p>
                        </div>
                        <div class="col d-flex justify-content-center align-items-center mr-2" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                          <p class="mt-3 headerTxt">Total</p>
                        </div>
                      </div>

                      <div class="" v-for="(tKits, indx) in lista.tratamientosKits" :key="indx">
                        <b-row class="text-center">
                          <b-col class="d-flex justify-content-center align-items-center mt-2">
                            <em v-if="tKits.banderaMovimientosHallPrio > 0"
                                class="startCircle" style="width: 18px; margin-right: 8px; cursor: pointer"
                                v-b-tooltip.hover.top.v-light
                                title="Enviar a hallazgos adicionales"
                                @click="enviarIndividualAHallazgo(tKits)"
                            ></em>
                            <div class="d-flex justify-content-center align-items-center p-2" style="min-height: 35px; ">
                              <p class="m-0 bodyTxt" style="font-weight: 600;" >{{ tKits.tratamiento }}</p>
                            </div>

                          </b-col>
                          <b-col class="d-flex justify-content-center align-items-center mt-2">
                            <p class="m-0 bodyTxt" >{{ tKits.cantidadMaxima }}</p>
                          </b-col>
                          <b-col class="d-flex justify-content-center align-items-center mt-2">
                            <p class="m-0 bodyTxt" >{{ tKits.precioUnitario | moneda}}</p>
                          </b-col>
                          <b-col v-if="existePlan || aplicaPromocionesTx" class="d-flex justify-content-center align-items-center mt-2 mr-2">
                            <p class="m-0 bodyTxt">{{ tKits.subtotal | moneda }}</p>
                          </b-col>
                          <b-col v-if="existePlan" class="d-flex justify-content-center align-items-center mt-2 mr-2">
                            <p class="m-0 bodyTxt">{{ tKits.descuentoPlan | moneda }}</p>
                          </b-col>
                      <b-col v-if="aplicaPromocionesTx" class="d-flex justify-content-center align-items-center mt-2 mr-2">
                            <div>
                              <TagPromocionV5 v-if="tKits.promocion == null"
                                              :promociones.sync="promociones"
                                              :tratamiento.sync="tKits"
                                              :totalPrioridadClinica.sync="cantidadtotalPrioridad"
                                              @restarPromocionAplicada="restarPromocionAplicada"
                                              :agrupadoPorOd="true"
                              ></TagPromocionV5>
                              <span v-if="tKits.promocion != null">
                                      <p class="m-0 bodyTxt"> <span v-b-tooltip.hover.lefttop.v-light
                                                                    :title="tKits.promocion.promocion"
                                                                    style="cursor: pointer"
                                      >{{ tKits.descuentoPromo | monedaEntero }} </span>
                                        <em v-if=" tKits.promocion.promocionForzosa === false "
                                            style="cursor: pointer"
                                            v-b-tooltip.hover.lefttop.v-light
                                            title="Quitar promoción"
                                            class="quitarPromo"
                                            @click="quitarPromoByOD(tKits)"
                                        ></em>
                                      </p>
                                    </span>
                            </div>
                          </b-col>
                             <b-col class="mr-2 mt-3">
                            <span class="m-0 bodyTxt">{{ (tKits.total !== null ? tKits.total:0) | moneda }} </span>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </b-collapse>
            </b-card>
          </div>
          <div class="d-flex justify-content-between mt-2 mb-2">
          <b-button pill variant="outline-info" size="sm"
                      v-if="idEtapaAnterior !== 101 && idEtapa != 97"
                      @click="rechazarParaEdicion()"

            >
              <span style="font-size: 11px">Volver a editar</span>
            </b-button>
            <div v-else></div>
            <div>
              <span class="text-2">Total de prioridad clínica: </span>
              <span class="text-3"> {{cantidadtotalPrioridad | monedaEntero}}</span>
            </div>
          </div>
        </div>
        <div v-else class="text-center">
          <p style="font-size: .8em;" v-if="!loaderPrioridad">Sin tratamientos Prioridad</p>
          <p v-else> Ordenando por Órgano dental  <b-spinner variant="success" small ></b-spinner> </p>
        </div>

        <b-modal
            size="lg"
            v-model="mostrarArgumentarioTx"
            scrollable
            hide-footer
            hide-header
        >
          <div style="display: flex;width: 100%;" class="mb-3">
            <div class="d-flex align-items-center detalle-formulario">
                <span class="detalle-formulario-h1 ml-3"
                      style="font-size: 20px; font-weight: bolder !important; color: var(--color-dentalia) !important;">
                Argumentario: {{datosArgumentarioTx.nombreTx}}
                </span>

            </div>
            <b-button class="button-dentalia-svg-4 mr-2" variant="primary"
                      @click="mostrarArgumentarioTx = false">
              <em class="close_x_svg icon-dentalia-svg-0" style="height: 16px; "></em>
            </b-button>
          </div>

          <ModalArgumentario v-if="mostrarArgumentarioTx"
                             :idTratamiento="datosArgumentarioTx.idTx"
                             :nombreTratamiento="datosArgumentarioTx.nombreTx"
                             :listaTrtConArgumentario="datosArgumentarioTx.listaTrtConArgumentario"/>
        </b-modal>
      </div>
</template>


<script>
import TagPromocionV5 from "@/version5/TagPromocionV5.vue";
import ModalArgumentario from "@/views/argumentario/ModalArgumentario.vue";

export default {
  name: "TablaPrioridadClinicaByOd",
  components: {ModalArgumentario, TagPromocionV5},
  props:{
    aplicaPromocionesTx: Boolean,
    existePlan: Boolean,
    tratamientosPrioridadPorOD: Array,
    promociones:Array,
    idPti: Number,
    idSolicitudEtapa: Number,
    idSolicitud: Number,
    nombrePlan: String,
    idEtapaAnterior: Number,
    loaderPrioridad: Boolean,
    totalPrioridadClinica: Number,

  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    existeCardActiva: false,
    cardSeleccionado: null,
    idEtapa: null,
    cantidadtotalPrioridad: 0,
    mostrarArgumentarioTx: false,
    datosArgumentarioTx: [],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idEtapa = this.$route.params.idEtapa;
      this.calcularTotalPrioridadOd();
  },
  watch:{
    totalPrioridadClinica(){
      this.cantidadtotalPrioridad = this.tratamientosPrioridadPorOD.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
        return vAnterior + vActual.inversionTotal;
      }, 0);
    }

  },
  methods: {
    agregarACarrito(tratamiento ){
      tratamiento.agregadoACarrito = true;
      if (tratamiento.tratamientosKits !== null && tratamiento.tratamientosKits.length > 0){
        tratamiento.tratamientosKits.forEach(tk => tk.agregadoACarrito = true)
      }


      this.$emit('agregarAResumenInversionOD', tratamiento)
    },
    quitarPromoByOD(item){

      if (item.idKitTratamiento === null){
        this.tratamientosPrioridadPorOD.forEach(tp => {
          tp.tratamientos.forEach(trat => {
            if (trat.idPtiTratamiento === item.idPtiTratamiento){
              trat.total = trat.total + trat.descuentoPromo;
              trat.descuentoPromo = 0;
              trat.promocion = null
            }

          })
          tp.descuentoPromo = tp.tratamientos.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
            return vAnterior + vActual.descuentoPromo;
          }, 0);

          tp.inversionTotal = tp.tratamientos.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
            return vAnterior + vActual.total;
          }, 0);


        })


      }
       else {

        this.tratamientosPrioridadPorOD.forEach(tp => {
          tp.tratamientos.forEach(trat => {
            if (trat.idKitTratamiento !== null && (trat.tratamientosKits !== null || trat.tratamientosKits.length > 0) ) {
              if (trat.idKitTratamiento === item.idKitTratamiento) {

                trat.tratamientosKits.forEach(tratKit => {
                  if (tratKit.idPtiTratamiento === item.idPtiTratamiento) {

                    tratKit.total = tratKit.total + tratKit.descuentoPromo;
                    trat.total = trat.total + tratKit.descuentoPromo;

                    tratKit.descuentoPromo = 0
                    tratKit.promocion = null;


                    trat.descuentoPromo = 0
                  }
                })

              }
            }

          })
          tp.descuentoPromo = tp.tratamientos.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
            return vAnterior + vActual.descuentoPromo;
          }, 0);

          tp.inversionTotal = tp.tratamientos.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
            return vAnterior + vActual.total;
          }, 0);


        })

      }

      this.$emit('montosByRetiroPromoOd', item)


      this.calcularTotalPrioridadOd();

    },
    restarPromocionAplicada(tratamiento){
      this.tratamientosPrioridadPorOD.forEach(tp => {
        tp.tratamientos.forEach(trat => {
            if (trat.idKitTratamiento !== null && (trat.tratamientosKits !== null || trat.tratamientosKits.length > 0) ) {
              if (trat.idKitTratamiento === tratamiento.idKitTratamiento) {
                trat.tratamientosKits.forEach(tratKit => {
                  if (tratKit.idPtiTratamiento === tratamiento.idPtiTratamiento) {
                    trat.descuentoPromo += tratKit.descuentoPromo;
                     trat.total = trat.total - tratKit.descuentoPromo;
                  }
                })

              }
            }

        })
          tp.descuentoPromo = tp.tratamientos.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
            return vAnterior + vActual.descuentoPromo;
          }, 0);

        tp.inversionTotal = tp.tratamientos.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
          return vAnterior + vActual.total;
        }, 0);


      })

      this.$emit("montoAhorradoPromoByOD", tratamiento);

      this.calcularTotalPrioridadOd();

    },
    calcularTotalPrioridadOd(){
      this.cantidadtotalPrioridad = this.tratamientosPrioridadPorOD.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
        return vAnterior + vActual.inversionTotal;
      }, 0);
    },
    
    rechazarParaEdicion(){
      this.$swal.fire({
        icon: "warning",
        html: '<div style="text-align:center;font-weight: 600; font-size: small">Enviar a edición de diagnóstico</div> <br>' +
            '<div style="text-align:center; font-size: small">Este PTI se enviará a edición de diagnóstico y no estará disponible para negociar ' +
            'hasta que se termine de editar, ¿desea continuar?</div>',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        confirmButtonColor: "#EEBA6D",
        cancelButtonColor: "#dfdfdf",
        customClass: {
          confirmButton: "rounded-pill text-small",
          cancelButton: " rounded-pill text-small text-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          const params = {
            idTipoRechazo: 6,
            idPti: this.idPti,
            idSolicitudFlujo: this.idSolicitudEtapa,
            idSolicitud: this.idSolicitud,
            idEtapa: this.$route.params.idEtapa
          }
          this.$http.put(this.$api + "procesoPtiV5/rechazarPti", params).then(resp => {
            if (resp.data.data){
              this.$swal.fire({
                icon: "success",
                html: '<div style="text-align:center;font-weight: 600; font-size: small">PTI enviado a diagnóstico exitosamente</div> <br>',
                focusConfirm: true,
                showCancelButton: false,
                confirmButtonText: "Cerrar",
                confirmButtonColor: "#dfdfdf",
                customClass: {
                  confirmButton: "rounded-pill text-small border-secondary text-secondary",
                },
              });
            }
          }).finally(() => {
            this.$router.push('/bandejaEmbajadorHallazgoV5');
          })
        }
      });
    },
    seleccionarCard(tratamientos, index) {
      this.$emit("dientesSeleccionados", tratamientos);
      this.cardSeleccionado = index;
      this.existeCardActiva = true;
    },
    deseleccionarCard() {
      this.$emit("dientesSeleccionados", []);
      this.cardSeleccionado = null;
      this.existeCardActiva = false;
    },
    enviarIndividualAHallazgo(tratamiento) {
      if (tratamiento.agregadoACarrito){
        this.$swal.fire({
          icon: "error",
          html: '<div style="text-align:center;font-weight: 600; font-size: small">No se puede enviar a hallazgos, ' +
              'el tratamiento esta agregado en el carrito </div> <br>',
        });
      } else if (tratamiento.promocion !== null) {
        this.$swal.fire({
          icon: "error",
          html: '<div style="text-align:center;font-weight: 600; font-size: small">No se puede enviar a hallazgos, ' +
              'el tratamiento tiene una promoción </div> <br>',
        });
      } else {
        this.$emit('enviarIndividualAHallazgoOd', tratamiento)
        tratamiento.clasificacion = 2;
        this.cantidadtotalPrioridad = this.cantidadtotalPrioridad - tratamiento.total;
      }
    },
    recalcularPorHallazgos(){
      this.cantidadtotalPrioridad = this.tratamientosPrioridadPorOD.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
        return vAnterior + vActual.inversionTotal;
      }, 0);
    },

    verArgumentario(idTx, nombre, kit){
      if(kit.length > 0){
        kit.forEach((k,i)=>{
          k.seleccionado = i === 0;
          k.nombreTratamiento = k.tratamiento;
        })
        kit = kit.filter(k=>k.argumentarioCompleto);
      }
      this.datosArgumentarioTx.idTx = kit.length > 0 ? kit[0].idTratamiento : idTx;
      this.datosArgumentarioTx.nombreTx =  nombre;
      this.datosArgumentarioTx.listaTrtConArgumentario = kit;
      this.mostrarArgumentarioTx = true;
    },
  }

}
</script>

<style scoped>
.txSinAcciones{
  min-width: 100%
}

.txConAcciones{
  min-width: 76%
}

.textoActivo{
  font-size: .7em !important;
  font-weight: bolder;
  color: #BFBFBF;
}

.agregadoCarrito{
  color: #4FB0B7;
  font-weight: 600;
}

.scrollable-container {
  overflow-y: auto;
  min-height: 55vh;
}

.cardSe {
  border: 1px solid #d6e7f3;
  border-radius: 16px;
  min-height: 60px;
}

.cardCerrada {
  border: 1px solid #d6e7f3;
  border-radius: 16px;
  height: 60px;
}

.cardSe.seleccionado {
  border-style: solid;
  border-width: 2px;
  border-color: #90d3dd;
  border-radius: 16px;
}
.cardSeTitle.seleccionado{
  font-weight: 600;
  font-size: 12px !important;
}
.cardSeTitle{
  font-size: .75em !important;
}

.leterSize{
  font-size: .75em !important;
  color: #4F4F4F;
}
.headerTxt{
  font-size: .8em;
  color: #4F4F4F;
  font-weight: 600;
}
.bodyTxt{
  font-size: .8em;
  color: #747474;
}
.thtable {
  font-size: .7em !important;
  font-weight: bolder;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgb(0 0 0 / 0%);
}
.text-2 {
  position: relative;
  color: #000000;
  font-size: 11px;
  font-weight: 600;
  line-height: 17.332px;
  text-align: center;
}
.text-3 {
  position: relative;
  color: #0069a9;
  font-size: 11px;
  font-weight: 600;
  line-height: 17.332px;
  text-align: center;
}
.table th, .table td {
  padding: 0.2rem;
  vertical-align: middle;
  border-top: 0px solid #ffffff;
  font-size: 12px;
}
</style>